import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import AppUtils from '@control-front-end/utils/utils';
import { Utils } from 'mw-style-react';
import {
  SEARCH_FORMS,
  GET_FORM,
  GET_FORMS,
} from '@control-front-end/common/constants/forms';
import SelectEntityField from '../SelectEntityField';

const initState = {
  list: [],
  limit: 15,
  offset: 0,
  endList: false,
  reqStatus: 'success',
};

/**
 * Поиск шаблонов акторов
 */
function SelectActorsTemplate(props) {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const [stateValue, setStateValue] = useState(props.value);
  const [templates, setTemplates] = useState(initState);

  useEffect(() => {
    const { value } = props;
    if (value && value.value && !value.title) {
      dispatch({
        type: GET_FORM.REQUEST,
        payload: { formId: value.value },
        callback: (data) =>
          setStateValue({ value: data.id, title: data.title }),
      });
    }
  }, []);

  const getData = (loadMore = false) => {
    const localState = loadMore ? templates : initState;
    dispatch({
      type: GET_FORMS.REQUEST,
      payload: {
        loadMore,
        localState,
        withDefault: true,
        formTypes: 'system,connector',
      },
      callback: (data) => setTemplates(data),
    });
  };

  const clearData = () => {
    setTemplates(initState);
  };

  /**
   * Обработка поискового запроса
   * @param q
   */
  const handleSearch = (query) => {
    if (!query.length) {
      getData();
      return;
    }
    if (query.length < 2) return;
    dispatch({
      type: SEARCH_FORMS.REQUEST,
      payload: { query },
      callback: (data) => setTemplates({ ...initState, ...data }),
    });
  };

  /**
   * Название шаблона
   * @returns {string|*}
   */
  const getTitle = (item) => {
    if (!item.isDefault) return item.title || item.name;
    if (item.ownerId === auth.id) return 'My Default';
    return `${item.ownerName || item.userName}'s Default`;
  };

  /**
   * Сортированный список шаблонов (дефолтные в конец)
   * @returns {array|*}
   */
  const getTplsList = () => {
    const tplsGroup = AppUtils.groupBy(templates.list, 'isDefault');
    let result = [];
    [tplsGroup[''] || [], tplsGroup.true || []].forEach((i) => {
      i.forEach((tpl) => {
        tpl.title = getTitle(tpl);
      });
      result = result.concat(Utils.sort(i, 'title'));
    });
    return result;
  };

  return (
    <SelectEntityField
      {...props}
      objType="template"
      list={getTplsList()}
      onSearch={handleSearch}
      onFocus={() => getData()}
      onBlur={() => clearData()}
      onScroll={() => getData(true)}
      value={stateValue}
    />
  );
}

SelectActorsTemplate.propTypes = {
  value: PropTypes.object,
};

export default SelectActorsTemplate;
